import './style.scss';
import Input from "../../components/common/input";
import React, {useState} from "react";
import DistrictForm from "../../components/districtForm";
import {addDistrict, clearAddDistrictAlert, clearAddDistrictErrors} from "../../actions/districts";
import {useDispatch, useSelector} from "react-redux";
import {route as SWITCH_DISTRICTS_ROUTE} from "../switchDistricts/"
import {Navigate, useNavigate} from "react-router-dom";
import Alert from "../../components/common/alert";

export const route = 'add-district';

const AddDistrict = (props) => {
  const [name, setName] = useState('');
  const [externalId, setExternalId] = useState('');
  const shouldLockForm = false;
  const errors = useSelector((state) => state.districts.addDistrictErrors);
  const addDistrictAlert = useSelector((state) => state.districts.addDistrictAlert);
  const addDistrictApiError = useSelector((state) => state.districts.addDistrictApiError);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onDismissAlert = () => {
    dispatch(clearAddDistrictErrors());
  }

  const onCancelAction = () => {
    dispatch(clearAddDistrictAlert());
    navigate('/switch-districts');
  }

  return (addDistrictAlert) ? <Navigate to={SWITCH_DISTRICTS_ROUTE} /> : (
    <div className='main-content'>
      <div className='add-district-header'>Create a New District</div>
      <div className='add-district-alerts'>
        {(addDistrictApiError) && <Alert onDismiss={onDismissAlert}>{addDistrictApiError}</Alert>}
      </div>
      <div className='add-district-container'>
        <DistrictForm
          submitLabel='Submit'
          submitAction={() => {dispatch(addDistrict(name, externalId))}}
          disabled={shouldLockForm}
          cancelAction={() => {onCancelAction()}}
        >

          <Input
            name='name'
            id='name'
            value={name}
            label='District Name*'
            type='text'
            changeAction={setName}
            errors={errors?.name}
          />

          <Input
            name='externalId'
            id='externalId'
            value={externalId}
            label='External ID*'
            type='text'
            changeAction={setExternalId}
            errors={errors?.externalId}
          />
        </DistrictForm>
      </div>
    </div>
  );
}

export default AddDistrict;